import convertPersonaToRecipientPersonaProps from './convertPersonaToRecipientPersonaProps';
import parseSuspectedDisplayNameEmailAddress from 'owa-readwrite-recipient-well/lib/utils/parseSuspectedDisplayNameEmailAddress';
var SEPARATOR_REGEX = new RegExp(';|\\n|\\r\\n', 'g');
export default function parsePastedTextForRecipients(pastedText) {
    var personas = [];
    var recipientList = pastedText.split(SEPARATOR_REGEX);
    recipientList.forEach(function (element) {
        var trimmedElement = element.trim();
        if (trimmedElement.length > 0) {
            // try to parse out a suspected name + email address combo
            var result = parseSuspectedDisplayNameEmailAddress(trimmedElement);
            personas.push(result);
        }
    });
    return convertPersonaToRecipientPersonaProps(personas, true /*validationNeeded*/);
}
//# sourceMappingURL=parsePastedTextForRecipients.js.map